import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AperturaPayload, ArticleData, StatusResponse, BlockRequest, BlockResponse } from 'src/app/models/opening';
import { environment as env } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class OpeningService {
  private baseUrl = `${env.apiCerberoUrl}`;

  constructor(private http: HttpClient) { }

  getCodeFromPublicUrl(url: string): string | null {
    const match = url.match(/PP\d+[A-Z]?/);
    return match ? match[0] : null;
  }

  getJsonUrlFromCode(code: string): string {
    return `https://s3-us-west-2.amazonaws.com/filesstaticpulzo/pulzo-lite/posts/${code}.json`;
  }

  getArticleFromCode(code: string): Promise<ArticleData> {
    const jsonUrl = this.getJsonUrlFromCode(code);
    return fetch(jsonUrl)
      .then((res) => {
        if (!res.ok) throw new Error('Error al cargar el archivo');
        return res.json();
      });
  }

  saveOpening(payload: AperturaPayload){
    return this.http.post<AperturaPayload>(`${this.baseUrl}/request?event=guardar-apertura`, payload);
  }

  checkSectionStatus(section: string){
    let payload = { "section": section }
    return this.http.post<StatusResponse>(`${this.baseUrl}/request?event=seccion-en-uso`, payload);
  }

  blockSection(payload: BlockRequest){
    return this.http.post<BlockResponse>(`${this.baseUrl}/request?event=bloquear-seccion`, payload);
  }

  getOpeningFromApi(section: string = 'home'): Promise<AperturaPayload> {
    const timestamp = new Date().getTime();
    //const url = `https://filesstaticpulzo.s3.us-west-2.amazonaws.com/pulzo-lite/jsons/regional/co/grid_new_full_${section}.json?t=${timestamp}`;
    const cleanSection = section.split('/').pop() || 'home';

    const url = `https://filesstaticpulzo.s3.us-west-2.amazonaws.com/pulzo-lite/jsons/regional/co/grid_new_full_${cleanSection}.json?t=${timestamp}`;
  
    console.log('[GET OPENING] URL solicitada:', url);

    return fetch(url)
    .then((res) => {
      if (!res.ok) {
        if (res.status === 404) {
          return {
            seccion: section,
            apertura: {
              openingType: 'normal',
              articles: []
            },
            grid: []
          } as AperturaPayload;
        }
        throw new Error(`Error al consultar la apertura para ${section}`);
      }
      return res.json();
    });
  }

  getSections(): Promise<{ Loc: string }[]> {
    const url = 'https://filesstaticpulzo.s3.us-west-2.amazonaws.com/pulzo-lite/sitemap/sections.json';
    return fetch(url)
      .then(res => {
        if (!res.ok) throw new Error('Error al cargar secciones');
        return res.json();
      });
  }

  getMenuSections(): Promise<{ key: string; name: string }[]> {
    const url = 'https://filesstaticpulzo.s3.us-west-2.amazonaws.com/pulzo-lite/menu-pulzo/menu.json';
  
    return fetch(url)
      .then(res => {
        if (!res.ok) throw new Error('Error al cargar secciones del menú');
        return res.json();
      })
      .then(data => {
        const sectionsValid = data.sections_valid;
  
        // Convertimos el objeto en un array
        return Object.entries(sectionsValid).map(([key, value]: [string, any]) => ({
          key,         // ejemplo: "bienestar"
          name: value.name // ejemplo: "Bienestar"
        }));
      });
  }
  
  
  
}
